var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreatedByIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50087 6.11089H4.88976V5.49978C4.88976 5.13312 4.64531 4.88867 4.27865 4.88867C3.91198 4.88867 3.66753 5.13312 3.66753 5.49978V6.11089H3.05642C2.68976 6.11089 2.44531 6.35534 2.44531 6.72201C2.44531 7.08867 2.68976 7.33312 3.05642 7.33312H3.66753V7.94423C3.66753 8.31089 3.91198 8.55534 4.27865 8.55534C4.64531 8.55534 4.88976 8.31089 4.88976 7.94423V7.33312H5.50087C5.86753 7.33312 6.11198 7.08867 6.11198 6.72201C6.11198 6.35534 5.86753 6.11089 5.50087 6.11089Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55556 0H4.88889C3.54444 0 2.44444 1.1 2.44444 2.44444C1.1 2.44444 0 3.54444 0 4.88889V8.55556C0 9.9 1.1 11 2.44444 11H6.11111C7.45556 11 8.55556 9.9 8.55556 8.55556C9.9 8.55556 11 7.45556 11 6.11111V2.44444C11 1.1 9.9 0 8.55556 0ZM7.33333 7.94444V8.55556C7.33333 9.22778 6.78333 9.77778 6.11111 9.77778H2.44444C1.77222 9.77778 1.22222 9.22778 1.22222 8.55556V4.88889C1.22222 4.21667 1.77222 3.66667 2.44444 3.66667H3.05556H6.11111C6.78333 3.66667 7.33333 4.21667 7.33333 4.88889V7.94444ZM9.77778 6.11111C9.77778 6.78333 9.22778 7.33333 8.55556 7.33333V4.88889C8.55556 3.54444 7.45556 2.44444 6.11111 2.44444H3.66667C3.66667 1.77222 4.21667 1.22222 4.88889 1.22222H8.55556C9.22778 1.22222 9.77778 1.77222 9.77778 2.44444V6.11111Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatedByIcon);
export default __webpack_public_path__ + "static/media/createdByIcon.d88786ca85d865a79edf45dc73e81b93.svg";
export { ForwardRef as ReactComponent };